/** Kontakte zu einem Unterrichtstermin (Schüler + Eltern). */

export function contactsForLesson(contacts, entry) {
  const studentIds = new Set((entry?.students || []).map((s) => String(s.id)));
  if (!studentIds.size) return [];
  return (contacts || []).filter((c) => {
    if (c.person_type === 'student' && studentIds.has(String(c.person_id))) return true;
    if (c.person_type === 'guardian' && studentIds.has(String(c.related_student_id))) return true;
    return false;
  });
}

export function parseHm(value) {
  const m = String(value || '').match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return `${m[1].padStart(2, '0')}:${m[2]}:00`;
}

export function lessonDurationMinutes(entry) {
  const stored = Number(entry?.duration_minutes);
  if (stored > 0) return stored;
  return durationMinutes(entry?.start, entry?.end);
}

export function endFromStart(startHm, minutes) {
  const parsed = parseHm(startHm);
  if (!parsed) return '';
  const [hour, minute] = parsed.split(':').map(Number);
  const total = (hour * 60 + minute + Number(minutes || 0)) % (24 * 60);
  const hh = String(Math.floor(total / 60)).padStart(2, '0');
  const mm = String(total % 60).padStart(2, '0');
  return `${hh}:${mm}`;
}

export function messageTargets(contacts, entry, audience) {
  const people = contactsForLesson(contacts, entry).filter((person) => person.user_id);
  if (audience === 'students') return people.filter((person) => person.person_type === 'student');
  if (audience === 'guardians') return people.filter((person) => person.person_type === 'guardian');
  if (typeof audience === 'string' && audience.startsWith('guardian:')) {
    const id = audience.slice('guardian:'.length);
    return people.filter((person) => person.person_type === 'guardian' && String(person.person_id) === id);
  }
  return people;
}

export function durationMinutes(start, end) {
  const [sh, sm] = String(start || '00:00').split(':').map(Number);
  const [eh, em] = String(end || '00:00').split(':').map(Number);
  return Math.max(15, (eh * 60 + em) - (sh * 60 + sm));
}

/** ISO-Wochentag 0=Mo … 6=So → Course.day_of_week (0=Mo). */
export function isoToCourseDow(isoDate) {
  const js = new Date(`${isoDate}T12:00:00`).getDay(); // 0=So
  return js === 0 ? 6 : js - 1;
}
